import { useSelector } from 'react-redux'

import { access } from '@driftt/traffic-control'

import { createGetWorkspaceOptions } from 'modules/workspaces/selectors'
import { ReportPage } from 'types/pages'
import { userHasOrgConversationReports } from 'utils/access'

export type FilterableEntityType =
  | 'workspace'
  | 'team'
  | 'teammate'
  | 'inbox'
  | 'botStatus'
  | 'widgetStatus'
  | 'classification'

const useAvailableFilters = ({
  reportType = ReportPage.Conversation,
  showAdvancedFilters,
}: {
  reportType?: ReportPage
  showAdvancedFilters?: boolean
}): FilterableEntityType[] => {
  const isConversationReport = [
    ReportPage.Conversation,
    ReportPage.Team,
  ].includes(reportType)
  const isService = reportType === ReportPage.Service
  const isCallReport = reportType === ReportPage.Call
  const isMeetingReport = reportType === ReportPage.Meeting
  const isRealTimeDashboard = reportType === ReportPage.RealTime
  const showMultiAgentPicker =
    userHasOrgConversationReports() &&
    ((isConversationReport && showAdvancedFilters) ||
      isMeetingReport ||
      isCallReport ||
      isRealTimeDashboard)
  const showTeamPicker =
    userHasOrgConversationReports() &&
    (isConversationReport ||
      isMeetingReport ||
      isCallReport ||
      isService ||
      isRealTimeDashboard) &&
    access.hasGates('has_beta_team_view')

  const hasAccessToManyWorkspaces =
    useSelector(createGetWorkspaceOptions(reportType)).length > 0

  const availableReportFilterTypes: FilterableEntityType[] = []
  showMultiAgentPicker && availableReportFilterTypes.push('teammate')
  showTeamPicker && availableReportFilterTypes.push('team')
  access.hasGates('workspace_settings') &&
    hasAccessToManyWorkspaces &&
    availableReportFilterTypes.push('workspace')
  isConversationReport &&
    showAdvancedFilters &&
    availableReportFilterTypes.push('botStatus', 'widgetStatus', 'inbox')
  isConversationReport &&
    showAdvancedFilters &&
    userHasOrgConversationReports() &&
    availableReportFilterTypes.push('classification')

  return availableReportFilterTypes
}

export default useAvailableFilters
